var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIndustry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 8.4l.743-.446a.5.5 0 01.757.43v1.233a.5.5 0 00.757.429L9.5 9.6l2-1.2.743-.446a.5.5 0 01.757.43V10a.5.5 0 00.5.5h1a.5.5 0 00.5-.5V3a.5.5 0 01.5-.5h5a.5.5 0 01.5.5v18a.5.5 0 01-.5.5h-17A.5.5 0 013 21V10.783a.5.5 0 01.243-.429L6.5 8.4zm0 2.1a.199.199 0 00-.3-.17l-1.457.874a.5.5 0 00-.243.428V19.5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1A.5.5 0 017 18h1a.5.5 0 01.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 00.5.5h2a.5.5 0 00.5-.5V8.25a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5v3.25a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5v-1a.199.199 0 00-.3-.17l-2.428 1.456-1.515.909a.5.5 0 01-.757-.429V10.5zM19 4a.5.5 0 01.5.5v1.25a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5V4.5A.5.5 0 0117 4h2zm-4.5 10.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1zM11 16a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1zm-4.5-1.5A.5.5 0 017 14h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H7a.5.5 0 01-.5-.5v-1z",
    fill: "currentColor"
  })));
}

export default SvgIndustry;